import React, { FC } from "react";
import { Alert, AlertKind } from "../../../../components";
import { connect } from "react-redux";
import { AnnouncementType, RootState } from "../../../../../../models";
import { Announcement } from "../../../../../../models/state";
import { getAnnouncementInfo } from "../../../../app/state/selectors";
import "./AnnouncementText.less";

interface StateProps {
    announcementInfo?: Announcement;
}

interface AnnouncementProps extends StateProps {
    typeId?: AnnouncementType;
}

const getAlertKind = (announcementInfo: Announcement): AlertKind => {
    // CF and SG are not using the same naming, do need to map the severity to the SG name
    switch (announcementInfo.severity) {
        case "alert":
            return "negative";
        case "warning":
        case "info":
        case "positive":
            return announcementInfo.severity;
        default:
            return "info";
    }
};

const AnnouncementText: FC<AnnouncementProps> = ({ announcementInfo, typeId = "top" }) => {
    if (!announcementInfo) {
        return null;
    }
    let displaySizeKind = true;
    if (typeId !== "top") {
        displaySizeKind = false;
        if (!announcementInfo.id?.includes(typeId)) {
            return null;
        }
    } else if (Array.isArray(announcementInfo.id) && announcementInfo.id.length) {
        // dont display in top of page when comp id is set in the announcement
        return null;
    }

    const alertKind = getAlertKind(announcementInfo);

    return (
        <div className="announcement-layout__announcementWrapper">
            {displaySizeKind ? (
                <Alert kind={alertKind} className="announcement-layout__alert" centered>
                    <>
                        <p className="announcement-layout__announcementText">
                            <span className="telia-sans-medium">{announcementInfo.heading}</span>
                        </p>
                        <div dangerouslySetInnerHTML={{ __html: announcementInfo.content }} />
                    </>
                </Alert>
            ) : (
                <Alert kind={alertKind} className="announcement-layout__alert" centered>
                    <>
                        <p className="announcement-layout__announcementText">
                            <span className="telia-sans-medium">{announcementInfo.heading}</span>
                        </p>
                        <div dangerouslySetInnerHTML={{ __html: announcementInfo.content }} />
                    </>
                </Alert>
            )}
        </div>
    );
};

const mapStateToProps = (state: RootState, ownProps?: AnnouncementProps): StateProps => ({
    announcementInfo: getAnnouncementInfo(state, ownProps?.typeId),
});

export default connect(mapStateToProps)(AnnouncementText);
